import React, { useContext, useMemo } from "react";
import { useTheme } from "styled-components";
import { Flex } from "reflexbox";
import LineTable from "./LineTable";
import { Heading, Body } from "../../UI/Text";
import formatter from "../../../modules/formatter";
import moment from "moment";
import _ from "lodash";
import ConfiguratorContext from "../../../context/configurator/ConfiguratorContext";

export const CustomerInfo = () => {
	const { quote } = useContext(ConfiguratorContext);
	const { shippingAddress, billingAddress } = quote || {};
	const addresses = [billingAddress, shippingAddress];
	const { sameAsShipping } = billingAddress || {};
	// function formatPhoneNumber(phoneNumberString) {
	//   var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
	//   var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
	//   if (match) {
	//     var intlCode = match[1] ? "+1 " : "";
	//     return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
	//   }
	//   return "";
	// }

	return (
		<Flex width={1} alignItems="flex-start" flexWrap="wrap">
			{/* <Flex
        className="print-col"
        width={[1, 1, 0.5, sameAsShipping ? 0.5 : 0.33]}
        pr="0.5rem"
        flexDirection="column"
      >
        <Heading>Customer</Heading>
        {companyName && (
          <Flex width={1} alignItems="center" justifyContent="space-between">
            <Body width="33.3333%" bold>
              Name:
            </Body>
            <Body width="66.6666%">{companyName}</Body>
          </Flex>
        )}
        {erpId && (
          <Flex width={1} alignItems="center" justifyContent="space-between">
            <Body width="33.3333%" bold>
              ID:
            </Body>
            <Body width="66.6666%">{erpId}</Body>
          </Flex>
        )}
        {firstName && (
            <Flex width={1} alignItems="center" justifyContent="space-between">
              <Body width="33.3333%" bold>
                First Name:
              </Body>
              <Body width="66.6666%">{firstName}</Body>
            </Flex>
          )}
          {lastName && (
            <Flex width={1} alignItems="center" justifyContent="space-between">
              <Body width="33.3333%" bold>
                Last Name:
              </Body>
              <Body width="66.6666%">{lastName}</Body>
            </Flex>
          )}
          {email && (
            <Flex width={1} alignItems="center" justifyContent="space-between">
              <Body width="33.3333%" bold>
                Email Address:
              </Body>
              <Body width="66.6666%">{email}</Body>
            </Flex>
          )}
          {phone && (
            <Flex width={1} alignItems="center" justifyContent="space-between">
              <Body width="33.3333%" bold>
                Phone Number:
              </Body>
              <Body width="66.6666%">{formatPhoneNumber(phone)}</Body>
            </Flex>
          )}
        {poNumber && (
          <Flex width={1} alignItems="center" justifyContent="flex-start">
            <Body width="33.3333%" bold>
              PO Number:
            </Body>
            <Body width="66.6666%">{poNumber}</Body>
          </Flex>
        )}
      </Flex> */}

			{addresses.map((address, i) => {
				const { Address, Address2, City, State, Zip, id, Name, AddressType } =
					address || {};
				if (!address) return null;
				if (i === 1 && sameAsShipping) return null;
				const headers = ["Billing Address", "Shipping Address"];

				return (
					<Flex
						className="print-col"
						key={id + "|address" + i}
						width={[1, 1, 0.5, sameAsShipping ? 0.5 : 0.5]}
						pl="0.5rem"
						flexDirection="column"
					>
						<Heading>{headers[i]}</Heading>
						{Name && (
							<Flex
								width={1}
								alignItems="center"
								justifyContent="space-between"
							>
								<Body width="33.3333%" bold>
									Name:
								</Body>
								<Body width="66.6666%">{Name}</Body>
							</Flex>
						)}
						{Address && (
							<Flex
								width={1}
								alignItems="center"
								justifyContent="space-between"
							>
								<Body width="33.3333%" bold>
									Address Line 1:
								</Body>
								<Body width="66.6666%">{Address}</Body>
							</Flex>
						)}
						{Address2 && (
							<Flex
								width={1}
								alignItems="center"
								justifyContent="space-between"
							>
								<Body width="33.3333%" bold>
									Address Line 2:
								</Body>
								<Body width="66.6666%">{Address2}</Body>
							</Flex>
						)}
						{City && (
							<Flex
								width={1}
								alignItems="center"
								justifyContent="space-between"
							>
								<Body width="33.3333%" bold>
									City:
								</Body>
								<Body width="66.6666%">{City}</Body>
							</Flex>
						)}
						{State && (
							<Flex
								width={1}
								alignItems="center"
								justifyContent="space-between"
							>
								<Body width="33.3333%" bold>
									Province/State:
								</Body>
								<Body width="66.6666%">{State}</Body>
							</Flex>
						)}
						{Zip && (
							<Flex
								width={1}
								alignItems="center"
								justifyContent="space-between"
							>
								<Body width="33.3333%" bold>
									Postal/Zip:
								</Body>
								<Body width="66.6666%">{Zip}</Body>
							</Flex>
						)}
					</Flex>
				);
			})}
		</Flex>
	);
};

export const CommunicationList = ({ communications }) => {
	if (!communications || !_.isArray(communications)) return null;

	return (
		<Flex width={1} flexDirection="column">
			{communications.map((item, i) => {
				const { id, comment, date, username } = item || {};
				return (
					<Flex
						key={id}
						width={1}
						justifyContent="space-between"
						alignItems="center"
					>
						<Body ellipsis>
							{`${moment(date).format("MM/DD/YYYY")}`}
							{" – "}
							{comment}
							{i === 0 ? " by " : " – "}
							{username}
						</Body>
					</Flex>
				);
			})}
		</Flex>
	);
};

const PrintQuote = React.forwardRef((props, ref) => {
	const theme = useTheme();
	const {
		lines: rows,
		lineCount: count,
		communications,
		lineLoading,
		isDealer,
		isPlane,
	} = props || {};

	const { quote } = useContext(ConfiguratorContext);

	const { id: quoteId, type, billingAddress } = quote || {};

	const price = useMemo(() => {
		let total = 0;
		let discountTotal = 0;
		if (quote?.lines && quote?.lines?.length > 0) {
			for (let line of quote?.lines) {
				console.log({ line });
				// DETAILS DO NOT EXIST ON THE LINE, NEED TO UPDATE LINE TABLE WITH THE DETAILS OR PULL THEM DYNAMICALLY
				// update to use get lines request based on quote instead of pulling directly. Get lines handles pulling the latest config data
				const { quantity = 1, price, dealerPrice, Details: d } = line;
				total += quantity * price;
				let discountPrice = !isPlane ? dealerPrice : 0;
				if (!!isDealer && !!isPlane) {
					const Details = JSON.parse(d || "[]");
					Details.forEach((Detail, i) => {
						console.log({ Detail });
						const { Value, Caption: _Caption } = Detail || {};

						const isMSRP = _Caption.startsWith("MSRP");
						const isDEALER = _Caption.startsWith("DEALER");

						if (!isMSRP && !isDEALER) return;
						if (Value === "***INCLUDED***") return;

						console.log({ isDEALER, Value });

						console.log({ Value, isDEALER, isMSRP });
						const val = Value.replace(/[^\p{L}0-9]/g, "") / 100;
						console.log({ val });

						if (isDealer) {
							if (isDEALER) {
								discountPrice += val;
							}
						}
					});
				}
				discountTotal += discountPrice * quantity;
			}

			if (isDealer)
				return (
					<Flex
						style={{ gap: "0.5rem" }}
						justifyContent="flex-end"
						alignItems="center"
					>
						<Body w="auto" bold>
							Total:
						</Body>
						<Body w="auto" bold right linethrough>
							${formatter.currency(total)}
						</Body>
						<Body w="auto" bold color={theme.secondary}>
							${formatter.currency(discountTotal)}
						</Body>
					</Flex>
				);

			return `Total: $${formatter.currency(total)}`;
		}

		return `Total: $${formatter.currency(0)}`;
	}, [quote, isDealer, theme.secondary, isPlane]);
	const { sameAsShipping } = billingAddress || {};

	const shipCode = useMemo(() => {
		return _.find(
			quote?.shipCodes || [],
			({ ShipVia }) => ShipVia === quote?.shipCode
		);
	}, [quote]);

	const poNumber = useMemo(() => quote?.poNumber || "", [quote]);

	return (
		<>
			<style type="text/css" media="print">
				{`
          .no-print { 
            display: none; 
          }
          
          @media print {
            .print-col {
              margin-bottom: -3rem;
              width: ${sameAsShipping ? "50%" : "50%"} !important;
            }
            #price {
              opacity: 1;
            }
            .printquote {
              display: block;
            }
            html,
            body {
              padding: 1rem;
              height: 99vh;
            }
          }
        `}
			</style>
			<style type="text/css">
				{`
          .no-summary {
            display: none;
          }
          .print-col {
            margin-bottom: 1rem;
          }
          @media print {
            .printquote {
              display: block;
            }
            #price {
              opacity: 1;
            }
            .no-summary {
              display: block;
            }
            html,
            body {
              height: 99vh;
            }
          }

        `}
			</style>

			{/* remove total cost and quote header on summary page */}
			<div
				className="printquote no-summary"
				ref={ref}
				style={{ width: "100%", height: "auto" }}
			>
				<Flex width={1} flexDirection="column" alignItems="flex-start">
					<Flex
						width={1}
						justifyContent="space-between"
						alignItems="flex-start"
					>
						<img
							width="150px"
							className="no-summary"
							src={theme.logo}
							alt="SwiftSell"
						/>
						<Flex justifyContent="flex-end" flexDirection="column">
							<Heading right className="no-summary">
								{`${["Quote", "Order", "Quote Request"][type - 1]} #${quoteId}`}
							</Heading>
							<Body right>{price}</Body>
							<Body bold right>
								Customer PO:{" "}
								<span style={{ color: theme.secondary }}>{poNumber}</span>
							</Body>

							{!!shipCode && !isPlane && (
								<Flex mb="1rem" width={1} justifyContent="space-between">
									<Body bold>Shipping Method:</Body>

									<Body bold right color={theme.secondary}>
										{shipCode?.description}
									</Body>
								</Flex>
							)}
						</Flex>
					</Flex>

					<CustomerInfo />

					<LineTable
						lineLoading={lineLoading}
						quote={quote}
						lines={rows}
						open
						lineCount={count}
						quoteId={quoteId}
						printQuote
					/>

					<CommunicationList communications={communications} />
				</Flex>
			</div>
		</>
	);
});

export default PrintQuote;
